import { render, staticRenderFns } from "./SectionsControl.vue?vue&type=template&id=60c8b484&"
import script from "./SectionsControl.vue?vue&type=script&lang=js&"
export * from "./SectionsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports